import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
const InterfaceSection = ({ image, features }) => (_jsxs(Stack, { direction: { xs: "column", md: "row" }, spacing: { xs: 3, md: 7 }, alignItems: "center", children: [_jsx(Box, { sx: {
                width: { xs: "100%", md: "800px" },
                minHeight: { xs: "120px", lg: "400px" },
                backgroundImage: {
                    xs: "none",
                    md: "url('/interface-bg.svg')",
                },
                p: { xs: 0, md: 3 },
                backgroundSize: "cover",
                border: { xs: "4px solid", md: "none" },
                borderColor: { xs: "primary.main" },
                "& div > div": {
                    height: "auto",
                },
            }, children: image }), features] }));
export default InterfaceSection;
